var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.061 13.439L14.475 8.85401C13.8084 8.21718 12.9219 7.86182 12 7.86182C11.0781 7.86182 10.1916 8.21718 9.52499 8.85401L4.93899 13.439C4.6576 13.7204 4.49951 14.1021 4.49951 14.5C4.49951 14.898 4.6576 15.2796 4.93899 15.561C5.22039 15.8424 5.60204 16.0005 5.99999 16.0005C6.39794 16.0005 6.7796 15.8424 7.06099 15.561L11.647 10.975C11.7408 10.8813 11.8679 10.8286 12.0005 10.8286C12.1331 10.8286 12.2602 10.8813 12.354 10.975L16.939 15.561C17.2204 15.8424 17.602 16.0005 18 16.0005C18.3979 16.0005 18.7796 15.8424 19.061 15.561C19.3424 15.2796 19.5005 14.898 19.5005 14.5C19.5005 14.1021 19.3424 13.7204 19.061 13.439Z",
    fill: "#A2272E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersbg);
export default __webpack_public_path__ + "static/media/careersbg.b9b52db62b9b9a031aed6cad357ff905.svg";
export { ForwardRef as ReactComponent };